<template>
	<qvoTitlebar appLogoFileName="ARIA-text-white.svg">
        <template v-slot:accountMenuList>
            <li>
                <router-link
                    to="/Account"
                    class="drop-menu-option"
                    title="Account"
                    label="Account"
                >
                    Account
                </router-link>
            </li>
            <li v-if="showTenantOptions">
                <router-link
                    to="/SelectTenant"
                    class="drop-menu-option"
                    title="Select Tenant"
                    label="Select Tenant"
                >
                    Select Tenant
                    <v-icon>mdi-swap-horizontal-circle-outline</v-icon>
                </router-link>
            </li>
        </template>
    </qvoTitlebar>
</template>

<script>
	/**
	 * @fileoverview titlebar.vue displays a title bar using the qvoTitlebar component.
	 * It relies on the qux-common code and vuex to map the state variables from the store files.
	 * 
	 * @components
	 * 		qvoTitlebar - title bar component from the common code
	 * 
	 * @author David Barnett <david.barnett@quavo.com>
	 */
	import qvoTitlebar from '@/qux-common/components/titlebar.vue';
    import { mapState } from "vuex";

	export default {
		name: 'titlebar',
		components: {
			qvoTitlebar
		},
        computed: {
             ...mapState({
                tenantId: (state) => state.account.tenantId,
                tenantList: (state) => state.account.tenantList
            }),
			/**
			 * Show tenant options if the user is an admin
			 * @returns true if tenantId is "master", false otherwise
			 */
            showTenantOptions() {
				return this.tenantList.length > 1;
			},
        }
	}
</script>

<!-- Styles defined in _titlebar.scss -->